export enum Packages {
  Free = 1,
  Pro = 2,
  Enterprise = 3,
  AdditionalUsers = 4,
  ThreatModule = 5
}
